import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { camelCaseKeys } from "mibaby-common/util/mapKeys";
import trivias from "./trivias";
import { jsx as _jsx } from "react/jsx-runtime";
var NumToBool = function NumToBool(t) {
  return Boolean(Number(t));
};

// server bools are string-numbers
var parser = {
  thumbnailEnabled: NumToBool,
  revealEnabled: NumToBool,
  revealLinkText: NumToBool
};
var parse = function parse(p) {
  var n = _objectSpread({}, p);
  for (var prop in parser) {
    if (n[prop]) {
      n[prop] = parser[prop](n[prop]);
    }
  }
  return n;
};
export var formatFromServer = function formatFromServer(props) {
  return parse(camelCaseKeys(props));
};
export var withFromServerMapper = function withFromServerMapper(Component) {
  return function (props) {
    return /*#__PURE__*/_jsx(Component, _objectSpread({}, formatFromServer(props)));
  };
};

/**
 * @typedef {TriviaDefinition & {props: CommonTriviaProps}} TriviaGroupValue
 * @typedef {{[key: string]: TriviaGroupValue[]}} TriviaGroup
 **/

/**
 * @param {CommonTriviaProps[]} items
 * @return {TriviaGroup}
 */
export var groupTrivias = function groupTrivias(items) {
  /** @type {TriviaGroup} */
  var group = {};
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.name && trivias[item.name]) {
        var trivia = trivias[item.name];
        var position = trivia.getPosition(item);
        if (!group.hasOwnProperty(position)) {
          group[position] = [_objectSpread(_objectSpread({}, trivia), {}, {
            props: item
          })];
        } else {
          group[position].push(_objectSpread(_objectSpread({}, trivia), {}, {
            props: item
          }));
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return group;
};
//# sourceMappingURL=util.js.map